module.exports = __webpack_public_path__ + "img/icon-link.14f5bb63.svg";